// ABI for the CodedEstateEvmInterface Solidity gateway
// Generated from coded-estate-evm/artifacts/contracts/CodedEstateEvmInterface.sol/CodedEstateEvmInterface.json

export const CodedEstateEvmInterfaceABI = [
  {
    "inputs": [
      {
        "internalType": "string",
        "name": "initialRentalContractAddress",
        "type": "string"
      },
      {
        "internalType": "uint256",
        "name": "_timelockDelay",
        "type": "uint256"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "string",
        "name": "eventType",
        "type": "string"
      },
      {
        "indexed": false,
        "internalType": "string",
        "name": "abciEvent",
        "type": "string"
      }
    ],
    "name": "AbciEvent",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "previousOwner",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "newOwner",
        "type": "address"
      }
    ],
    "name": "OwnershipTransferred",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "string",
        "name": "newAddress",
        "type": "string"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "effectiveTimestamp",
        "type": "uint256"
      }
    ],
    "name": "RentalContractAddressChangeProposed",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "string",
        "name": "oldAddress",
        "type": "string"
      },
      {
        "indexed": true,
        "internalType": "string",
        "name": "newAddress",
        "type": "string"
      }
    ],
    "name": "RentalContractAddressChanged",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "sender",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "string",
        "name": "contractAddress",
        "type": "string"
      },
      {
        "indexed": false,
        "internalType": "bytes",
        "name": "wasmMsgExecute",
        "type": "bytes"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "fundsLen",
        "type": "uint256"
      }
    ],
    "name": "RentalExecuted",
    "type": "event"
  },
  {
    "inputs": [],
    "name": "changeEffectiveTimestamp",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "executeNewRentalContractAddress",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "bytes",
        "name": "wasmMsgExecute",
        "type": "bytes"
      }
    ],
    "name": "executeRental",
    "outputs": [
      {
        "internalType": "bytes",
        "name": "",
        "type": "bytes"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "bytes",
        "name": "wasmMsgExecute",
        "type": "bytes"
      },
      {
        "components": [
          {
            "internalType": "string",
            "name": "denom",
            "type": "string"
          },
          {
            "internalType": "uint256",
            "name": "amount",
            "type": "uint256"
          }
        ],
        "internalType": "struct INibiruEvm.BankCoin[]",
        "name": "funds",
        "type": "tuple[]"
      }
    ],
    "name": "executeRentalWithFunds",
    "outputs": [
      {
        "internalType": "bytes",
        "name": "",
        "type": "bytes"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "owner",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "pendingRentalContractAddress",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "string",
        "name": "newAddress",
        "type": "string"
      }
    ],
    "name": "proposeNewRentalContractAddress",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "renounceOwnership",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "rentalContractAddress",
    "outputs": [
      {
        "internalType": "string",
        "name": "",
        "type": "string"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "bytes",
        "name": "wasmMsgExecute",
        "type": "bytes"
      },
      {
        "internalType": "string",
        "name": "paymentDenom",
        "type": "string"
      },
      {
        "internalType": "uint256",
        "name": "paymentAmountBank",
        "type": "uint256"
      },
      {
        "internalType": "address",
        "name": "paymentErc20",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "useErc20Amount",
        "type": "uint256"
      }
    ],
    "name": "setReservationForShortTerm",
    "outputs": [
      {
        "internalType": "bytes",
        "name": "",
        "type": "bytes"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "timelockDelay",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "newOwner",
        "type": "address"
      }
    ],
    "name": "transferOwnership",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  }
];

